/**
 * Извлекает доменную часть (хост) из строки URL.
 *
 * Поддерживаемые форматы URL:
 * - Протокол-относительные URL (`//example.com/path`)
 * - Абсолютные URL со схемой HTTP/HTTPS (`http://example.com/path`, `https://example.com/path`)
 * - Пути без схемы (возвращает первый сегмент пути как есть)
 *
 * @kind helper
 *
 * @param url - Строка URL, из которой нужно извлечь домен.
 * @returns Доменная часть URL (например, `"example.com"`), или пустая строка, если домен не удалось определить.
 *
 * @example
 * getUrlDomain('https://example.com/path'); // 'example.com'
 * getUrlDomain('//example.com/path');       // 'example.com'
 * getUrlDomain('http://example.com');       // 'example.com'
 */
export const getUrlDomain = (url: string) =>
    (url.startsWith('//') ? url.slice(2) : url.replace(/^https?:\/?\/?/i, '')).split('/')[0] ?? '';
